module.exports = __webpack_public_path__ + "01_medium_black.357a0e42.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/01_medium_black.png
// module id = RWfh
// module chunks = 0